export default "__VITE_ASSET__CsQXvAOH__"